import { procoreClient } from "./client";

type Uuid = string;

type BimLevel = {
    elevation: number;
    id: Uuid;
    location_id: Uuid;
};

type DrawingGroupItem = {
    bim_file_revision_instance_id: Uuid;
    file_info: {
        bim_file: {
            file_name: string;
        };
        bim_file_revision: {
            download_url: string;
        };
    };
    id: Uuid;
    platform_file_status: string;
    scene_version_status: string;
};

type DrawingMapping = {
    id: Uuid;
    bim_file_revision_instance_id: Uuid;
    point_a: { x: number; y: number };
    point_b: { x: number; y: number };
    sheet_dimensions: { width: number; height: number };
    use_for_2d_nav: boolean;
};

type BimPlans = {
    id: Uuid;
    bim_level: BimLevel;
    name: string;
    drawing_group: {
        drawing_group_items: DrawingGroupItem[] | null;
    };
    drawing_mappings: DrawingMapping[];
    model_mapping: {
        mapping: {
            id: Uuid;
            point_a: { x: number; y: number; z: number };
            point_b: { x: number; y: number; z: number };
        };
    };
    use_for_2d_nav: boolean;
};

type BimPlansData = {
    plans: BimPlans[];
};

export async function getBimPlans(params: {
    companyId: number;
    projectId: number;
    modelRevisionId: Uuid;
}): Promise<BimPlans[]> {
    const response = await procoreClient<{ data: BimPlansData }>(
        `/rest/v2.0/companies/${params.companyId}/projects/${params.projectId}/bim/model_revisions/${params.modelRevisionId}/plans/extended?include_deleted_sheets=false`,
        {
            method: "GET",
        },
    );

    return response.data.plans;
}
